module.exports = __webpack_public_path__ + "resources/img/main01_gov.18511357d30f936bd965ccaf58ca1332.png";